import { render, staticRenderFns } from "./DisplayImage.vue?vue&type=template&id=a09e4268&"
import script from "./DisplayImage.vue?vue&type=script&lang=ts&"
export * from "./DisplayImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports